import type { EventFilter } from "@/Modules/Chat/WebSocketManager";
import { MessageTypeWebSocket } from "@/Modules/Chat/Models/WebSocket";
import type { ErrorMessageWebSocket } from "../Models/WebSocket/Error";
import { APP_ROUTES } from "@/Generated/Routes/paths";

import AppRouter from "@/Router";

import useChatStore, { type ChatStore } from "../Store";
import useVideoCallStore, { type VideoCallStore } from "@/Modules/VideoCall/Store";

import { isObject } from "@/Utils/Objects";
import { waitFor } from "@/Utils/Promises";

export interface ExtraParamsConnectionMessageItem {
  chatStore: ChatStore;
  videoCallStore: VideoCallStore;
}

export const isErrorDoubleConnectionMessage = (message: unknown): message is ErrorMessageWebSocket => {
  return isObject(message) && message.type === MessageTypeWebSocket.ERROR && message.error_code === 409;
};

export const errorDoubleConnectionHandler = async (
  _message: ErrorMessageWebSocket,
  { chatStore = useChatStore(), videoCallStore = useVideoCallStore() }: ExtraParamsConnectionMessageItem
): Promise<undefined> => {
  chatStore.closeWebSocket();
  await waitFor(1);

  videoCallStore.updateShowConfig(false);
  videoCallStore.updateNextCallOptions(undefined);

  AppRouter.push({ name: APP_ROUTES.chat.connected.root.name });

  return Promise.resolve(undefined);
};

export default {
  isType: isErrorDoubleConnectionMessage,
  handler: errorDoubleConnectionHandler,
} as EventFilter<ExtraParamsConnectionMessageItem>;
